import React from "react";
import HeaderBread from "../../../components/HeaderBread";
import Layout from "../../../Layout";
import CustomHeaderTitle from "../../../components/constants/CustomHeaderTitle";
import SeoMetaTagInput from "../../../components/SeoMetaTagInput/SeoMetaTagInput";

const CreateSeoMetaTag = () => {
  const navigation = [
    { title: "Home", route: "/" },
    { title: "SEO Meta Tag List", route: "/website/webpages/seo-meta-tag" },
    { title: "Add SEO Meta Tag", route: "/website/webpages/seo-meta-tag/add" },
  ];

  return (
    <Layout type={"create_per"} module_data={"SEO Meta Tag"}>
      <CustomHeaderTitle title={"Create SEO Meta Tag"} />
      <HeaderBread navigation={navigation} title={"Add SEO Meta Tag"} />
      <SeoMetaTagInput seoMetaTag={{}} />
    </Layout>
  );
};

export default CreateSeoMetaTag;
